import React from "react";
import ReactDOM from "react-dom";
import { Button, Popover, Overlay, OverlayTrigger } from "react-bootstrap";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import modelCustomization from "images/model-customization.png";
import hyperparameterTuning from "images/hyperparameter-tuning.png";
import academicWheel from "images/academic-wheel.png";

import styles from "./style.module.css";

export default class ModelLoadingIndicator extends React.PureComponent {
  render() {
    const { isQuickRun, notebookProgress } = this.props;
    const displayInfo = {};
    if (isQuickRun) {
      displayInfo.src = academicWheel;
      displayInfo.text = "Hyperparameter Tuning";
      displayInfo.class = styles.loadingIndicatorPopover2;
      displayInfo.popover = "left";
    } else if (notebookProgress < 100) {
      displayInfo.src = modelCustomization;
      displayInfo.text = "Model Customization: Creating Notebooks";
      displayInfo.class = styles.loadingIndicatorPopover1;
      displayInfo.popover = "right";
    } else {
      displayInfo.src = hyperparameterTuning;
      displayInfo.text = "Hyperparameter Tuning";
      displayInfo.class = styles.loadingIndicatorPopover2;
      displayInfo.popover = "left";
    }
    return (
      <div className={styles.loadingIndicatorWrapper}>
        <div className={isQuickRun ? styles.aWheel : styles.loadingIndicatorImage}>
          <img src={displayInfo.src} alt={displayInfo.text} />
          {/* <OverlayTrigger
            placement="right"
            overlay={<Popover id="step1" className={styles.loadingIndicatorPopover}>
              <div>{displayInfo.text}</div>
            </Popover>}
          >
            <div className={styles.loadingIndicatorStep1} />
          </OverlayTrigger>
          <OverlayTrigger
            placement="left"
            overlay={<Popover id="step2" className={styles.loadingIndicatorPopover}>
              <div>{displayInfo.text}</div>
            </Popover>}
          >
            <div className={styles.loadingIndicatorStep2} />
          </OverlayTrigger> */}
          <Popover
            id="loadingStep"
            placement={displayInfo.popover}
            className={styles.loadingIndicatorPopover + " " + displayInfo.class}
          >
            <div>{displayInfo.text}</div>
          </Popover>
        </div>
      </div>
    );
  }
}
